module.exports = __webpack_public_path__ + "static/media/Syracuse.89e922b8.jpg";